import { searchString } from '@/services/router/search-scalars';

/**
 * The hand-off params a wizard step carries.
 *
 * Both are written by the upload screen when it starts the import, and read by Cancel import so
 * it can return the reader where the upload screen's own Cancel would have.
 */
export type WizardSearch = {
  /** The screen that started the import. */
  previous_route?: string;
  /** How to address the object type's page, which the import's own id cannot answer. */
  object_type_slug?: string;
};

/**
 * `validateSearch` replaces this route's search, so the incoming params are spread to preserve
 * the global ones the page does not own (`masq_account_id`, …) and only these two are narrowed.
 */
// oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
export function validateWizardSearch(search: Record<string, unknown>): Record<string, unknown> & WizardSearch {
  return {
    ...search,
    previous_route: searchString(search.previous_route),
    object_type_slug: searchString(search.object_type_slug),
  };
}
